import { render } from "./CrossIcon.vue?vue&type=template&id=6be701ab&ts=true"
import script from "./CrossIcon.vue?vue&type=script&lang=ts"
export * from "./CrossIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__